const Estadisticas = () => {
  return (
    <div>
      <div className="d-flex justify-content-center mt-5">
        <h2>Page Estadisticas</h2>
      </div>
    </div>
  );
};

export default Estadisticas;